import React, { useEffect, useRef, useState } from "react";
import { APISD } from "../../../../../../config/apisd";
import { APIMS } from "../../../../../../config/apims";

import Modal from "react-bootstrap/Modal";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
// import { toast } from "react-toastify";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";

const DONE_MESSAGE = "Semua siswa sudah ditambahkan di semester 2.";

// const getUserId = () => {
//   const direct = localStorage.getItem("user_id") || localStorage.getItem("id");
//   if (direct) return direct;
//   try {
//     const user = JSON.parse(localStorage.getItem("user") || "null");
//     return user?.id || user?.data?.id || "";
//   } catch (_) { return ""; }
// };

const getUserId = () =>
  (localStorage.getItem("id_admin") || "").replace(/[|&;$%@"<>()+,]/g, "");

export default function LanjutSemesterModal({ onHide, onSaved, semester, academicYear, branches = [], initialBranch, semesters = [], show = true }) {
  const [branch, setBranch] = useState(() => branches.some((item) => String(item.branch_code) === String(initialBranch)) ? initialBranch : branches[0]?.branch_code || "");
  const [school, setSchool] = useState("");
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [completed, setCompleted] = useState(false);
  const savingRef = useRef(false);
  const [check, setCheck] = useState({ key: "", loading: false, ready: false, empty: false });
  const token = localStorage.getItem("token");
  const level = localStorage.getItem("level") || "";
  const yearId = academicYear?.id || semester?.ysb_academic_year_id;
  const key = JSON.stringify(["rombel-duplikat-semester-v1", yearId, semester?.id, branch, school]);

  useEffect(() => {
    let cancelled = false;
    setSchools([]);
    setSchool("");
    setMessage("");
    setError("");
    if (!branch) { setLoading(false); return undefined; }
    setLoading(true);
    APIMS.get(`/api/access/schools?page=1&limit=1000&ascending=1&branch=${encodeURIComponent(branch)}&level=${encodeURIComponent(level)}`, {
      headers: { Authorization: `${token}`, "Content-Type": "application/json" },
    }).then((response) => {
      if (cancelled) return;
      let rows = response?.data?.data || [];
      if (["developer", "superadmin"].includes(level)) rows = rows.filter((item) => String(item.ysb_branch_id) === String(branch));
      if (branch === "BKS") rows = rows.filter((item) => item.school_code !== "BASEMENT_BEKASI");
      setSchools([...rows].sort((a, b) => (a.school_name || "").localeCompare(b.school_name || "", "id")));
    }).catch((err) => {
      if (!cancelled) setError(err?.response?.data?.message || "Gagal memuat sekolah. Pilih ulang cabang untuk mencoba lagi.");
    }).finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [branch, token, level]);

  const sourceSemester = semesters.find((item) => Number(item.semester) === 1 && (
    String(item.ysb_academic_year_id) === String(yearId) ||
    (semester?.name_year && String(item.name_year) === String(semester.name_year))
  ));
  // School responses may group students by class. Count student rows, not classes.
  const collectStudents = (value) => {
    if (Array.isArray(value)) return value.flatMap(collectStudents);
    if (!value || typeof value !== "object") return [];
    if (value.ysb_student_id || value.student_id || value.student?.id) return [value];
    for (const field of ["students", "data_students", "data_siswa", "siswa", "student_rombels", "data", "classes", "kelas"]) {
      if (Array.isArray(value[field])) return collectStudents(value[field]);
    }
    return [];
  };
  const loadStudents = async (semesterId) => {
    const response = await APISD.post("/api/student-rombels", {
      ysb_academic_year_id: yearId,
      ysb_semester_id: semesterId,
      ysb_branch_id: branch,
      ysb_school_id: school,
    }, { headers: { Authorization: `${token}`, "Content-Type": "application/json" } });
    const body = response?.data;
    if (body?.error === true || body?.success === false) throw new Error(body.message || "Gagal mengecek siswa.");
    if (!Array.isArray(body?.data) && !Array.isArray(body?.data?.students)) {
      throw new Error("Format daftar siswa belum dapat dibaca.");
    }
    const rows = collectStudents(body.data);
    const total = body.total == null ? null : Number(body.total);
    // Do not claim completion if a response could be truncated or unrecognized.
    const complete = total === null ? rows.length > 0 : Number.isFinite(total) && total === rows.length;
    return { rows, complete, empty: total === 0 && rows.length === 0 };
  };
  const studentId = (row) => {
    const id = row.ysb_student_id || row.student_id || row.student?.id;
    if (!id) throw new Error("ID siswa tidak ditemukan pada respons. Status belum bisa dipastikan.");
    return String(id);
  };
  const checkSchool = async () => {
    if (!sourceSemester?.id) throw new Error("Semester 1 pada tahun ajaran aktif tidak ditemukan.");
    const [source, target] = await Promise.all([loadStudents(sourceSemester.id), loadStudents(semester.id)]);
    const targetIds = new Set(target.rows.map(studentId));
    return {
      empty: source.empty,
      unknown: !source.complete || !target.complete,
      done: source.complete && target.complete && source.rows.length > 0 && source.rows.every((row) => targetIds.has(studentId(row))),
    };
  };

  useEffect(() => {
    let cancelled = false;
    setCompleted(false);
    setMessage("");
    setError("");
    setCheck({ key, loading: !!school, ready: false, empty: false });
    if (!school || !branch) return undefined;
    checkSchool().then((result) => {
      if (cancelled) return;
      setCompleted(result.done);
      setMessage(
        result.done
          ? DONE_MESSAGE
          : result.empty
          ? "Tidak ada siswa pada semester 1 untuk dilanjutkan."
          : result.unknown
          ? "Status seluruh siswa belum dapat dipastikan. Klik Simpan untuk melanjutkan; siswa yang sudah terdaftar akan dilewati oleh sistem."
          : "Seluruh siswa pada sekolah ini akan dilanjutkan ke kelas yang sama pada semester 2."
      );
      setCheck({ key, loading: false, ready: true, empty: result.empty });
    }).catch((err) => {
      if (cancelled) return;
      setMessage("Status siswa belum dapat dicek. Klik Simpan untuk melanjutkan; siswa yang sudah terdaftar akan dilewati oleh sistem.");
      setCheck({ key, loading: false, ready: !!sourceSemester?.id, empty: false });
    });
    return () => { cancelled = true; };
    // Recheck whenever the selected scope changes; ignore stale responses.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, token, sourceSemester?.id]);

  const save = async (event) => {
    event.preventDefault();
    if (savingRef.current || loading || !branch || !school || !yearId || !sourceSemester?.id || Number(semester?.semester) !== 2) return;
    if (completed || check.key !== key || !check.ready || check.loading || check.empty) return;
    const userId = getUserId();
    if (!userId) { setError("ID pengguna login tidak ditemukan. Sesuaikan getUserId dengan penyimpanan data login aplikasi."); return; }
    savingRef.current = true;
    setSaving(true);
    setError("");
    try {
      let current = { done: false, empty: false };
      try { current = await checkSchool(); } catch (_) { /* Duplication endpoint skips existing students. */ }
      if (current.done || current.empty) {
        setCompleted(current.done);
        setMessage(current.done ? DONE_MESSAGE : "Tidak ada siswa pada semester 1 untuk dilanjutkan.");
        setCheck({ key, loading: false, ready: true, empty: current.empty });
        return;
      }
      const response = await APISD.post("/api/student-rombels/duplikat-semester", {
        ysb_academic_year_id: yearId,
        ysb_semester_id: sourceSemester.id,
        ysb_branch_id: branch,
        ysb_school_id: school,
        user_id: userId,
      }, { headers: { Authorization: `${token}`, "Content-Type": "application/json" } });
      if (response?.data?.success === false || response?.data?.status === false || response?.data?.error === true) {
        throw new Error(response?.data?.message || "Gagal melanjutkan siswa ke semester 2.");
      }

      const result = response.data;
      const sourceCount = Number(result.total_source);
      const createdCount = Number(result.total_created);
      const skippedCount = Number(result.total_skipped);
      if (!Number.isFinite(sourceCount) || !Number.isFinite(createdCount) || !Number.isFinite(skippedCount)) {
        setMessage(result.message || "Penyimpanan berhasil. Pilih ulang sekolah untuk mengecek status siswa.");
      } else if (sourceCount === 0) {
        setCheck({ key, loading: false, ready: true, empty: true });
        setMessage("Tidak ada siswa pada semester 1 untuk dilanjutkan.");
      } else if (createdCount + skippedCount === sourceCount && Number(result.target_semester?.semester) === 2) {
        setCompleted(true);
        setMessage(DONE_MESSAGE);
      } else {
        setMessage(result.message || "Sebagian siswa belum berhasil dilanjutkan. Silakan periksa data kembali.");
      }
      // Refresh data parent setelah penyimpanan berhasil.
      if (onSaved) {
        try {
          await onSaved();
        } catch (_) {
          /* Penyimpanan tetap dianggap berhasil walaupun refresh parent gagal. */
        }
      }

      // toast.success(result.message || "Data siswa berhasil dilanjutkan ke semester 2.");
       ToastSuccess.fire({
                icon: "success",
                title:  "Data siswa berhasil dilanjutkan ke semester 2",
              });
      onHide();
    } catch (err) {
      setError(err?.response?.data?.message || err.message || "Gagal menyimpan. Silakan coba lagi.");
    } finally { savingRef.current = false; setSaving(false); }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="lanjut-semester-title"
    >
      <div className="sims-modal-header">
        <div>
          <h5 id="lanjut-semester-title" className="sims-modal-title">
            Lanjut Semester 2
          </h5>
        </div>
        <button
          type="button"
          className="sims-modal-close"
          onClick={onHide}
          disabled={saving}
          aria-label="Tutup modal"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <form onSubmit={save}>
        <div className="sims-modal-body">
          <div style={{fontSize: "14px"}}>
            Tahun Ajaran {academicYear?.name_year || semester?.name_year || "-"} · Semester 2 (Aktif)
          </div>

          {/* <div
            className="notification is-info is-light"
            style={{ fontSize: "14px", marginTop: "12px", marginBottom: "18px" }}
            role="note"
          >
            Pilih cabang dan sekolah untuk mengecek apakah siswa Semester 1 dapat dilanjutkan ke Semester 2.
            Jika tersedia, klik <strong>Simpan</strong> untuk melanjutkan seluruh siswa pada sekolah tersebut.
          </div> */}

          <div className="sims-form-grid">
            <div className="sims-form-group">
              <label className="sims-form-label" htmlFor="lanjut-cabang">
                Cabang <span>*</span>
              </label>
              <select
                id="lanjut-cabang"
                name="ysb_branch_id"
                className="sims-form-select"
                value={branch}
                disabled={saving}
                required
                onChange={(event) => {
                  setBranch(event.target.value);
                  setSchool("");
                  setSchools([]);
                  setMessage("");
                  setCompleted(false);
                  setError("");
                }}
              >
                <option value="">Pilih Cabang</option>
                {branches.map((item) => (
                  <option key={item.branch_code} value={item.branch_code}>
                    {item.branch_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="sims-form-group">
              <label className="sims-form-label" htmlFor="lanjut-sekolah">
                Nama Sekolah <span>*</span>
              </label>
              <select
                id="lanjut-sekolah"
                name="ysb_school_id"
                className="sims-form-select"
                value={school}
                disabled={saving || loading || !branch}
                required
                onChange={(event) => {
                  setSchool(event.target.value);
                  setMessage("");
                  setError("");
                }}
              >
                <option value="">
                  {!branch ? "Pilih Cabang terlebih dahulu" : loading ? "Memuat data sekolah..." : "Pilih Sekolah"}
                </option>
                {schools.map((item) => (
                  <option key={item.school_code} value={item.school_code}>
                    {item.school_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {check.loading && <p role="status" className="mb-3" style={{fontSize: "14px"}}>Mengecek siswa semester 1 dan semester 2...</p>}
          {message && <div style={{fontSize: "14px"}} className={`notification ${completed ? "is-success" : "is-info"} is-light`} role="status">{message}</div>}
          {error && <div className="notification is-danger is-light" role="alert">{error}</div>}
        </div>

        <div className="sims-modal-footer">
          <button type="button" className="sims-modal-cancel" disabled={saving} onClick={onHide}>
            Batal
          </button>
          <button
            type="submit"
            className="sims-modal-submit"
            disabled={saving || loading || !branch || !school || !yearId || !sourceSemester?.id || completed || check.key !== key || !check.ready || check.loading || check.empty}
          >
            {saving ? (
              <>
                <span className="sims-button-spinner" />
                Menyimpan...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faFloppyDisk} />
                Simpan
              </>
            )}
          </button>
        </div>
      </form>
    </Modal>
  );
}
